// Mock data for Design Matrix Portfolio

export const portfolioProjects = [
  {
    id: 1,
    title: "Luxor Estate Group",
    category: "Real Estate Platform",
    description: "A sophisticated digital presence for a premium real estate portfolio, featuring interactive property showcases and AI-powered search.",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=80",
    tags: ["Branding", "Web Development", "AI Integration"],
    year: "2024",
    impact: "340% increase in qualified leads"
  },
  {
    id: 2,
    title: "Velocity Fitness",
    category: "Health & Wellness App",
    description: "A transformative mobile experience combining personalized training programs with real-time performance analytics.",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200&q=80",
    tags: ["Mobile App", "UX Design", "Brand Identity"],
    year: "2024",
    impact: "50K+ active users in 6 months"
  },
  {
    id: 3,
    title: "Noir Atelier",
    category: "Fashion E-Commerce",
    description: "An elevated online boutique experience that merges editorial aesthetics with seamless commerce functionality.",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=80",
    tags: ["E-Commerce", "Art Direction", "Custom CMS"],
    year: "2023",
    impact: "180% revenue growth year-over-year"
  },
  {
    id: 4,
    title: "Quantum Ventures",
    category: "Investment Platform",
    description: "A cutting-edge fintech dashboard that transforms complex financial data into actionable intelligence.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
    tags: ["FinTech", "Data Visualization", "Web App"],
    year: "2024",
    impact: "$12M+ managed assets within first quarter"
  },
  {
    id: 5,
    title: "Aurelia Hospitality",
    category: "Luxury Hotel Brand",
    description: "A complete digital ecosystem for a boutique hotel chain, from booking systems to guest experience platforms.",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80",
    tags: ["Hospitality", "Booking System", "Brand Strategy"],
    year: "2023",
    impact: "95% direct booking rate"
  },
  {
    id: 6,
    title: "Cerebral AI",
    category: "SaaS Platform",
    description: "An intelligent content generation platform powered by advanced AI, designed for enterprise-scale marketing teams.",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&q=80",
    tags: ["AI/ML", "SaaS", "Enterprise"],
    year: "2024",
    impact: "200+ enterprise clients"
  }
];

export const services = [
  {
    id: 1,
    pillar: "Digital Architecture & Web Design",
    tagline: "Engineering Digital Experiences That Perform",
    description: "We craft bespoke, high-performance websites that merge artistic vision with technical excellence. Every project is built with React and enhanced with GSAP animations for fluid, memorable interactions.",
    details: [
      "Mobile-first responsive design",
      "Custom UI/UX with accessibility standards",
      "SEO-ready infrastructure and optimization",
      "GSAP scroll animations and micro-interactions",
      "Secure hosting environments (AWS, Vercel, Hostinger)",
      "Core Web Vitals optimization",
      "Progressive Web App (PWA) capabilities",
      "Analytics integration and conversion tracking"
    ],
    deliverables: "Fully deployed website, source code, hosting setup, SSL certificates, and technical documentation.",
    maintenance: true
  },
  {
    id: 2,
    pillar: "Brand Identity & Creative Direction",
    tagline: "Crafting Visual Languages for Modern Businesses",
    description: "Your brand is more than a logo—it's a complete visual ecosystem. We develop consistent, premium brand identities that command attention and build trust across every touchpoint.",
    details: [
      "Strategic brand positioning and research",
      "Custom logo design and brand marks",
      "Comprehensive brand style guides",
      "Digital banner and social media templates",
      "Business stationery (cards, letterheads, proposals)",
      "AI-generated studio-quality brand photography",
      "Typography and color system development",
      "Brand guidelines documentation"
    ],
    deliverables: "Complete brand package: logos (all formats), style guide, stationery suite, digital assets, and high-resolution AI-generated photography.",
    maintenance: false
  },
  {
    id: 3,
    pillar: "Growth Intelligence & AI Automation",
    tagline: "Scaling Your Business with Cutting-Edge Technology",
    description: "We leverage AI and automation to transform how you capture leads, engage customers, and scale operations. From intelligent receptionists to content engines, we build systems that work 24/7.",
    details: [
      "AI Receptionists for 24/7 lead capture and qualification",
      "Automated appointment booking and CRM integration",
      "Social media strategy and content planning",
      "Google Ads and Facebook Ads campaign management",
      "AI-powered content generation engines",
      "Email marketing automation and sequences",
      "Customer feedback and review management systems",
      "Performance analytics and conversion optimization"
    ],
    deliverables: "Deployed AI systems, advertising campaigns, content calendar, automation workflows, and monthly performance reports.",
    maintenance: true
  }
];

export const philosophyContent = {
  headline: "From Foundation to Growth",
  subheadline: "Where Strategy Meets Artistry",
  story: [
    "We don't just build websites. We architect digital experiences that mirror reality—your reality. Every pixel, every interaction, every line of code is intentionally crafted to reflect your vision and amplify your impact.",
    "Design Matrix was founded on a singular belief: that exceptional digital experiences are not a luxury—they're a necessity. In a world where attention is currency, your digital presence must command respect, inspire trust, and drive measurable growth.",
    "We combine technical mastery with artistic vision, strategic thinking with meticulous execution. Our process begins with understanding your business objectives, then we engineer solutions that don't just meet expectations—they exceed them."
  ],
  values: [
    {
      title: "Precision Engineering",
      description: "Every project is built with obsessive attention to detail and performance."
    },
    {
      title: "Strategic Innovation",
      description: "We leverage cutting-edge technology to create competitive advantages."
    },
    {
      title: "Measurable Impact",
      description: "Your success is our metric. We build for growth, not just aesthetics."
    }
  ]
};

export const contactInfo = {
  email: "hello@designmatrix.agency",
  phone: "+1 (555) 123-4567",
  address: "Miami, FL",
  social: {
    linkedin: "https://linkedin.com/company/designmatrix",
    instagram: "https://instagram.com/designmatrix",
    twitter: "https://twitter.com/designmatrix"
  }
};
